import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "staff-performance-scores-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "basic-table table-responsive" }
const _hoisted_5 = { class: "table mb-0" }
const _hoisted_6 = { class: "employee-info d-flex align-items-center" }
const _hoisted_7 = { class: "img rounded-circle" }
const _hoisted_8 = ["alt", "src"]
const _hoisted_9 = { class: "d-block fw-medium" }
const _hoisted_10 = { class: "text-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mb-lg-20\" data-v-a5367ce4><h5 class=\"mb-0\" data-v-a5367ce4>Staff Performance Scores</h5><div class=\"dropdown action-opt\" data-v-a5367ce4><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-a5367ce4><i class=\"ri-more-2-fill\" data-v-a5367ce4></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-a5367ce4><li data-v-a5367ce4><button class=\"dropdown-item\" data-v-a5367ce4>This Day</button></li><li data-v-a5367ce4><button class=\"dropdown-item\" data-v-a5367ce4>This Week</button></li><li data-v-a5367ce4><button class=\"dropdown-item\" data-v-a5367ce4>This Month</button></li><li data-v-a5367ce4><button class=\"dropdown-item\" data-v-a5367ce4>This Year</button></li></ul></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          alt: employee.name,
                          src: employee.image,
                          class: "rounded-circle"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(employee.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(employee.score), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}